import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDataset, apiError } from '../../../api/datasets';
/**
 * PATCH a dataset and refresh the caches. When removed fields hold imported values
 * the server answers 409 "confirm_field_removal": ask the agent, then resend.
 */
export function useSaveDataset(datasetId, onError, onSaved) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (body) => {
            try {
                return await updateDataset(datasetId, body);
            }
            catch (e) {
                const err = apiError(e);
                if (err.code === 'confirm_field_removal' && err.error && window.confirm(err.error)) {
                    return updateDataset(datasetId, { ...body, confirm_field_removal: true });
                }
                throw e;
            }
        },
        onSuccess: (dataset) => {
            queryClient.setQueryData(['dataset', datasetId], dataset);
            queryClient.invalidateQueries({ queryKey: ['datasets'] });
            onSaved?.(dataset);
        },
        onError: (e) => {
            const err = apiError(e);
            if (err.code !== 'confirm_field_removal')
                onError(err.error ?? 'Erreur lors de l\'enregistrement.');
        },
    });
}
